import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

import TimeAgo from '../TimeAgo';
import Card from '../Card';
import Avatar from '../Avatar';
import Button from '../Button';

function SheetCard({sheet, action, active}) {
  if (!action) {
    // Default to a "View" action if none is provided.
    action = <Button to={`/sheet/${sheet.templateId || sheet.template.id}/${sheet.id}`}>View</Button>;
  }

  if (action.type === Button) {
    // Force action buttons to be secondary according to the style guide.
    action = React.cloneElement(action, {secondary: true});
  }

  return (
    <Card active={active}>
      <Header active={active}>
        <H1>{sheet.template.name}</H1>
        <H2>{sheet.name || '(Unnamed Sheet)'}</H2>
      </Header>
      <Card.Footer
        start={(
          <UserDetails>
            <Avatar size="2.75rem" user={sheet.user} />
            <Metadata>
              <Username title={sheet.user.userName}><Link to={`/users/${sheet.user.id}`}>{sheet.user.userName}</Link></Username>
              <Timestamp title={new Date(sheet.dates.lastModified).toLocaleString()}>
                Updated <TimeAgo date={sheet.dates.lastModified} />
              </Timestamp>
            </Metadata>
          </UserDetails>
        )}
        end={action}
      />
    </Card>
  );
}

const Header = styled.div`
  padding: ${props => props.active ? '1.75rem 1.75rem 1.875rem 1.75rem' : '1.875rem'};
`;

const H1 = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 500;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`;

const H2 = styled.h2`
  margin: 0;
  margin-top: 0.625rem;
  font-size: 1.125rem;
  font-weight: 400;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`;

const UserDetails = styled.div`
  display: flex;
`;

const Metadata = styled.div`
  flex: 1;
  padding: 0 0.875rem;
  min-width: 0;
`;

const Username = styled.p`
  margin: 0;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Timestamp = styled.small`
  display: block;
  margin-top: 0.375rem;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default SheetCard;